import { Custom } from '@authFlow/utils/authFlowFlags';

export const PRO = 'pro';
export const GURU = 'guru';
export const BASE = 'base';
export const BUSINESS = 'business';
export const TA_PRO = 'ci-pro';

export const TRIAL_OFFERS = {
  ORIGINAL: {
    [PRO]: 'pro-signup-trial',
    [GURU]: 'guru-signup-trial',
  },
  [Custom.competitiveIntelligence]: {
    [PRO]: 'frigohfx',
    [GURU]: '1r21yuk3',
  },
  [Custom.backlinko]: {
    [PRO]: '0qvbdjfw',
    [GURU]: 'm8vmqkm2',
  },
  [Custom.contentMarketingPlatform]: {
    [GURU]: 'cmp-guru-trial-signup',
  },
  [Custom.extendedTrial]: {
    [PRO]: '3k24pucp',
    [GURU]: 'k8gduopn',
  },
  [Custom.contentToolkit]: {
    [BASE]: 'm2s8a9dq',
  },
  [Custom.localToolkit]: {
    [BASE]: '5nm5awdw',
    [PRO]: 'fteh2zhq',
  },
  [Custom.advertisingToolkit]: {
    [BASE]: 'x9c5s2lk',
    [PRO]: '6l58pefg',
  },
  [Custom.aiToolkit]: {
    [BASE]: 'gxzgiyju',
  },
  [Custom.socialToolkit]: {
    [BASE]: 'ng6tbs7i',
    [BUSINESS]: 'qf8ilcsd',
  },
  [Custom.trafficToolkit]: {
    [PRO]: '3nmd8bq6',
  },
  [Custom.prToolkit]: {
    [BASE]: '7nj9nm04',
    [PRO]: 'zcbmy86w',
  },
  app: {
    ['content-shake']: 'pqt7o6xq',
    ['local-advanced']: 'er681pyo',
  },
  [Custom.aiSeo]: {
    ['starter']: '6h2bcoyr',
    ['pro']: 'i6h94qu7',
  },
  personalised: {
    advertising: '3yhv1jdz',
    content: '73aqa7hn',
    local: 'g9g8hife',
    [PRO]: 'pro-signup-trial',
    [GURU]: 'guru-signup-trial',
  },
};

export const APPS_OFFERS = {
  [Custom.smm]: 'kqr3hbop',
  [Custom.contentAI]: 'l9clx7es',
  ['local-advanced']: 'cspc69m4',
};
